import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoftLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 0H9.05349V8.55349H0.5V0Z",
			fill: "#F25022"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.94652 0H18.5V8.55349H9.94652V0Z",
			fill: "#7FBA00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 9.44653H9.05349V18H0.5V9.44653Z",
			fill: "#00A4EF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.94652 9.44653H18.5V18H9.94652V9.44653Z",
			fill: "#FFB900"
		})
	]
});
export default SvgMicrosoftLogo;
